export const getArticleByIdTypes = {
  REQUEST: 'ARTICLE_GET_REQUEST',
  SUCCESS: 'ARTICLE_GET_SUCCESS',
  FAILED: 'ARTICLE_GET_FAILED',
};
export const setCurrentPage = {
  REQUEST: 'SET_CURRENT_PAGE_ARTICLES',
};
export const getArticlesTypes = {
  REQUEST: 'ARTICLES_GET_REQUEST',
  SUCCESS: 'ARTICLES_GET_SUCCESS',
  FAILED: 'ARTICLES_GET_FAILED',
};
export const getTaxonomyArticlesTypes = {
  REQUEST: 'GET_TAXONOMY_ARTICLES_REQUEST',
  SUCCESS: 'GET_TAXONOMY_ARTICLES_SUCCESS',
  FAILURE: 'GET_TAXONOMY_ARTICLES_FAILURE',
};
export const getArticleListTypes = {
  REQUEST: 'ARTICLE_GET_LIST_REQUEST',
  SUCCESS: 'ARTICLE_GET_LIST_SUCCESS',
  FAILED: 'ARTICLE_GET_LIST_FAILED',
};
export const getArticleBySlugTypes = {
  REQUEST: 'ARTICLE_GET_BY_SLUG_REQUEST',
  SUCCESS: 'ARTICLE_GET_BY_SLUG_SUCCESS',
  FAILED: 'ARTICLE_GET_BY_SLUG_FAILED',
  DISMOUNT: 'ARTICLE_DISMOUNT',
};
export const getArticleCoverImagesTypes = {
  REQUEST: 'ARTICLE_GET_COVER_IMAGES_REQUEST',
  SUCCESS: 'ARTICLE_GET_COVER_IMAGES_SUCCESS',
  FAILED: 'ARTICLE_GET_COVER_IMAGES_FAILED',
  CLEAR: 'ARTICLE_COVER_IMAGES_CLEAR',
};
export const clickOnRequestInfoTypes = {
  CLICK_REQUEST_INFO: 'AD_REQUEST_INFO_CLICK',
};
export const clickOnShareTypes = {
  CLICK: 'SHARE_ICON_CLICK',
};
